import React,{Component} from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";

import Button from '@material-ui/core/Button';
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';

import Api from "../../../libraries/api";
import ErrorHandling from "../../../libraries/error-handling";
import { history } from "../../../shared/configure-store";

require('dotenv').config();
const validator = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});

class BanksEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},

            id: '',
            name: '',
            branch: '',
            address: '',
            beneficiary_acc_no: '',
            beneficiary_name: '',
            currency: '',
            
            rows: [],
            sendPageNumber: '',
            sendPerPage: '',
            total: 0,
            perPage: 10,
            currentPage: 1,
            currentPageTable: 0,
            totalData: 0,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - Edit Bank';

        const id = this.props.match.params.id;

        Api.get('/bank/'+id).then(resp => {
            if (resp.data) {
                let data = resp.data;
                this.setState({
                    id: data.id,
                    name: data.name,
                    branch: data.branch,
                    address: data.address,
                    beneficiary_acc_no: data.beneficiary_acc_no,
                    beneficiary_name: data.beneficiary_name,
                    currency: data.currency,
                });
            }
        }).catch(err => {
            console.log(err);
        });
    }

    handleChange (e, prop){
        this.setState({ [prop]: e.target.value });
    };

    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const id = this.props.match.params.id;
        if (!validator.allValid()) {
            this.setState({ errors: validator.getErrorMessages() });
            return false;
        }

        this.setState({ errors: {}, loadingButton: true });

        let params = {
            name : this.state.name,
            branch : this.state.branch,
            address : this.state.address,
            beneficiary_acc_no : this.state.beneficiary_acc_no,
            beneficiary_name : this.state.beneficiary_name,
            currency : this.state.currency,
        };

        Api.patch('/bank/' + id, params, false).then(resp => {
            this.setState({ loadingButton: true });
            history.push('/banks');
            this.showMessage(true, 'Bank updated');
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)){

            } else {
                this.setState({ errors: err.errors, loadingButton: false });
                this.showMessage(false, 'Invalid format data');
            }
        });

    };

    handleGo  = (link) => {
        history.push(link);
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Edit Bank</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/banks" >Bank</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Edit</li>
                        </ol>
                    </nav>

                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <form name="edit" id="editType" className="row" noValidate>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Name</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='name'
                                        name="name"
                                        label="Name"
                                        autoComplete="off"
                                        onChange={(e) => this.handleChange(e, 'name')}
                                        value={this.state.name}
                                        fullWidth
                                    />
                                    {validator.message('name', this.state.name, 'required')}
                                    <div className='text-danger'>{this.state.errors.name}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Branch</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='branch'
                                        name="branch"
                                        label="Branch"
                                        autoComplete="off"
                                        onChange={(e) => this.handleChange(e, 'branch')}
                                        value={this.state.branch}
                                        fullWidth
                                    />
                                    {validator.message('branch', this.state.branch, 'required')}
                                    <div className='text-danger'>{this.state.errors.branch}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Address</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='address'
                                        name="address"
                                        label="Address"
                                        autoComplete="off"
                                        onChange={(e) => this.handleChange(e, 'address')}
                                        value={this.state.address}
                                        fullWidth
                                    />
                                    {validator.message('address', this.state.address, 'required')}
                                    <div className='text-danger'>{this.state.errors.address}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Beneficiary Account Number</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='beneficiary_acc_no'
                                        name="beneficiary_acc_no"
                                        label="Beneficiary Account Number"
                                        autoComplete="off"
                                        onChange={(e) => this.handleChange(e, 'beneficiary_acc_no')}
                                        value={this.state.beneficiary_acc_no}
                                        fullWidth
                                    />
                                    {validator.message('beneficiary_acc_no', this.state.beneficiary_acc_no, 'required')}
                                    <div className='text-danger'>{this.state.errors.beneficiary_acc_no}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Beneficiary Name</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='beneficiary_name'
                                        name="beneficiary_name"
                                        label="Beneficiary Name"
                                        autoComplete="off"
                                        onChange={(e) => this.handleChange(e, 'beneficiary_name')}
                                        value={this.state.beneficiary_name}
                                        fullWidth
                                    />
                                    {validator.message('beneficiary_name', this.state.beneficiary_name, 'required')}
                                    <div className='text-danger'>{this.state.errors.beneficiary_name}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Currency</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='currency'
                                        name="currency"
                                        label="Currency"
                                        autoComplete="off"
                                        onChange={(e) => this.handleChange(e, 'currency')}
                                        value={this.state.currency}
                                        fullWidth
                                        select
                                    >
                                        <MenuItem value="IDR">IDR</MenuItem>
                                        <MenuItem value="USD">USD</MenuItem>
                                    </TextField>
                                    {validator.message('currency', this.state.currency, 'required')}
                                    <div className='text-danger'>{this.state.errors.currency}</div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <Button className="mr-3" variant="contained" onClick={() => this.handleGo('/banks')}>Cancel</Button>
                                <Button variant="contained" color="primary" className="mr-3" onClick={this.handleSubmit} disabled={this.state.loadingButton && 'disabled' }>
                                    Submit{ this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                </Button>
                            </div>
                            <ToastContainer autoClose={3000} />
                        </form>
                    </div>
                </div>
                <ToastContainer autoClose={3000} />
            </div>
        )
    }
}

export default BanksEdit;